module.exports = __webpack_public_path__ + "img/xp-coin.4d8b64c5.png";